module.exports = __webpack_public_path__ + "img/classifyIco10.47e5e1dc.png";